module.exports = "/_next/static/images/ahn-9331efa24bd2e87900fa1490165c2252.svg";